import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=6846%3A20190
 *
 * @param {SvgIconProps} props - svg props
 */
export const OpenInMultipleIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M8 8.5C8 8.22386 7.77614 8 7.5 8H6.5C6.22386 8 6 8.22386 6 8.5V16.5C6 16.7761 6.21887 17 6.49502 17C8.26182 17 14.2708 17 16.5031 17C16.7792 17 17 16.7761 17 16.5V15.5C17 15.2239 16.7761 15 16.5 15H8V8.5Z' fill={color}/>
            <path d='M10.5 3C10.2239 3 10 3.22386 10 3.5V12.5001C10 12.7762 10.2239 13.0001 10.5 13.0001H21.5C21.7761 13.0001 22 12.7762 22 12.5001V3.5C22 3.22386 21.7761 3 21.5 3L10.5 3ZM20 11H12V7H20V11Z' fill={color}/>
            <path d='M4 12.5C4 12.2239 3.77614 12 3.5 12H2.5C2.22386 12 2 12.2239 2 12.5L2 20.5C2 20.7761 2.21883 21 2.49497 21C4.27806 21 10.3794 21 12.5046 21C12.7807 21 13 20.7761 13 20.5V19.5C13 19.2239 12.7761 19 12.5 19H4V12.5Z' fill={color}/>
        </SvgIcon>
    )
}

export default OpenInMultipleIcon
